import { get } from 'app/shared/utils/fetchr';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { MCP_KEYS } from 'app/modules/mcp/queries/keys';

export type McpConsentStatusResponse = {
  feature_enabled: boolean;
  org_mcp_enabled: boolean;
  terms_accepted: boolean;
  has_usage_permission: boolean;
  can_connect: boolean;
};

export const useMcpConsentStatus = (
  options?: Omit<
    UseQueryOptions<McpConsentStatusResponse>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    queryKey: MCP_KEYS.consentStatus(),
    queryFn: () => get<McpConsentStatusResponse>('/v1/mcp/consent-status'),
    ...options,
  });
